export type PremiumDeltaDirection = "increase" | "decrease" | "none";

export function formatPremiumDelta(delta: number | null): {
  text: string;
  color: string;
  direction: PremiumDeltaDirection;
} {
  const cents = Math.round((delta ?? 0) * 100);
  if (cents === 0)
    return { text: "$0.00", color: "text.primary", direction: "none" };
  const abs = (Math.abs(cents) / 100).toFixed(2);
  return cents > 0
    ? { text: `+$${abs}`, color: "error.main", direction: "increase" }
    : { text: `−$${abs}`, color: "success.main", direction: "decrease" };
}
